import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames/bind';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import * as findStoresActions from 'yoda-site-components/lib/actions/FindStoresAction';
import {
    URL_CHECKOUT_SHIPPING,
    SRV_STS_STORE_DISTANT_FROM_ZIP,
} from 'yoda-checkout-components/lib/common/Constants';
import { AMR_CO_EDIT_SHIPPING_DELIVERY } from 'yoda-checkout-components/lib/common/AmrConstants';
import PickupStoreDetails from 'yoda-checkout-components/lib/components/PickupStoreDetails/PickupStoreDetails';
import {
    FINANCING_SUCCESS_MESAAGE,
    DISCOUNT_REMOVED_MESSAGE,
} from 'yoda-checkout-components/lib/common/LabelConstants';
import MessageBox from 'yoda-core-components/lib/components/MessageBox/MessageBox';
import Button from 'yoda-core-components/lib/components/Button';
import * as checkoutAnalyticsActions from 'yoda-checkout-components/lib/actions/CheckoutAnalyticsAction';
import * as PlaceOrderActions from 'yoda-checkout-components/lib/actions/PlaceOrderActions';

import { isDistantBillingAddress } from 'yoda-checkout-components/lib/helpers/Utils/Utils';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import checkoutStaticText from '../../../../../helpers/LabelConstantsCheckout';
import ShippingAddressDetails from '../../../../../components/ShippingAddressDetails/ShippingAddressDetails';
import PickupPersonInfo from '../../../../../components/PickupPersonInfo/PickupPersonInfo';
import ShowItemDetailsLink from '../../../../../components/ShowItemDetailsLink/ShowItemDetailsLink';
import * as storeActions from '../../../../../actions/GetStoreAction';
import OrderInfoAction from '../../../../../actions/OrderInfoAction';
import { getProductPPIds, skipShippingMethodSelection } from '../../../../../helpers/Utils/Utils';
import * as checkoutPageActions from '../../../../../actions/CheckoutPageActions';

import * as styles from './ShippingReviewSection.css';
import DistantStoreMessage from '../../../../../components/DistantStoreMessage/DistantStoreMessage';
import PromiseDeliveryDates from '../../../../../components/PromiseDeliveryDates/PromiseDeliveryDates';

const cx = classNames.bind(styles);

export function ShippingReviewSection({
    shippingGroupInfo,
    orderCharges,
    shipToStore,
    storeDetails,
    warnings,
    rewardOrPromoFinanceMessage,
    actions,
    enableSkipShippingMethodSelections,
    isNative,
}) {
    if (isEmpty(shippingGroupInfo)) {
        return null;
    }

    function selectedSTSStoreData() {
        const storeId = get(shippingGroupInfo, 'store.id', '');
        // eslint-disable-next-line no-nested-ternary
        return shippingGroupInfo.type === 'STORE' && storeId
            ? isEmpty(shipToStore.selectedStoreInfo)
                ? { storeDetails: storeDetails[storeId] }
                : shipToStore.selectedStoreInfo
            : {};
    }

    function navigateShippingPage() {
        // Addressing bug MCYODA-20658
        const payload = {
            isPreLoadCall: false,
        };
        actions.getOrderInfo(payload);
        const path = URL_CHECKOUT_SHIPPING;
        actions.initNewCheckoutSectionsClientSideActions(path, true);
    }

    function renderShippingToHomeDetails() {
        if (shippingGroupInfo.type === 'HOME') {
            return (
                <div className={dt(['mt-6'])}>
                    <ShippingAddressDetails address={shippingGroupInfo.address} source="review" />
                </div>
            );
        }
        return null;
    }

    function renderShippingToStoreDetails() {
        if (
            shippingGroupInfo.type === 'STORE' &&
            shippingGroupInfo.store &&
            shippingGroupInfo.store.id
        ) {
            const selectedStore = isEmpty(shipToStore.selectedStoreInfo)
                ? { storeDetails: storeDetails[shippingGroupInfo.store.id] }
                : shipToStore.selectedStoreInfo;
            return (
                <div>
                    <PickupStoreDetails selectedStore={selectedStore} />
                    <div>
                        <PickupPersonInfo pickupPersonInfo={shippingGroupInfo.pickup} />
                    </div>
                </div>
            );
        }
        return null;
    }

    function renderEditShippingButton() {
        return (
            enableSkipShippingMethodSelections && (
                <div id={AMR_CO_EDIT_SHIPPING_DELIVERY}>
                    <Button
                        buttonId="editshipping"
                        automationId="addressList-edit-btn"
                        buttonType="Link"
                        size="Sm"
                        onClick={navigateShippingPage}
                    >
                        {checkoutStaticText.EDIT_SHIPPING}
                    </Button>
                </div>
            )
        );
    }
    const selectedStoreData = selectedSTSStoreData();
    const isShowDistantMessage = isDistantBillingAddress(warnings, SRV_STS_STORE_DISTANT_FROM_ZIP);
    return (
        <div
            className={`${cx('reviewShippingSection')} ${dt([
                'bg-white',
                'lg:p-6',
                'lg:pb-4',
                'lg:m-2',
                'smMd:pt-6',
                'smMd:px-0',
            ])}`}
            data-automation-id="at-review-shipping-section-container"
            data-ppId={getProductPPIds(shippingGroupInfo.bagItems)}
        >
            {!isEmpty(rewardOrPromoFinanceMessage) &&
                rewardOrPromoFinanceMessage.showPromoSuccess &&
                !rewardOrPromoFinanceMessage.closePromoSuccessMsgClicked && (
                    <div className={dt(['lg:pt-0', 'pb-2'])}>
                        <MessageBox
                            type="success"
                            level="section"
                            hasClose
                            onClose={rewardOrPromoFinanceMessage.onClosePromoSuccessMsg}
                        >
                            {rewardOrPromoFinanceMessage.rewardOrPromoFinanceData
                                .isSpecialFinancingSelected && (
                                <span className={cx('orderSuccessStatus')}>
                                    {FINANCING_SUCCESS_MESAAGE}
                                </span>
                            )}
                            {rewardOrPromoFinanceMessage.rewardOrPromoFinanceData
                                .isRewardRemoved && (
                                <p>
                                    {
                                        rewardOrPromoFinanceMessage.rewardOrPromoFinanceData
                                            .rewardPercentage
                                    }
                                    % {DISCOUNT_REMOVED_MESSAGE}
                                </p>
                            )}
                        </MessageBox>
                    </div>
                )}
            {isShowDistantMessage && <DistantStoreMessage selectedStore={selectedStoreData} />}
            <ShowItemDetailsLink isNative={isNative} />
            {renderShippingToHomeDetails()}
            {renderShippingToStoreDetails()}
            <PromiseDeliveryDates
                orderItems={shippingGroupInfo}
                reviewPage
                orderCharges={orderCharges}
            />
            {renderEditShippingButton()}
        </div>
    );
}

ShippingReviewSection.propTypes = {
    shippingGroupInfo: PropTypes.objectOf(
        PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string])
    ),
    actions: PropTypes.objectOf(PropTypes.func),
    orderCharges: PropTypes.arrayOf(PropTypes.object),
    shipToStore: PropTypes.objectOf(PropTypes.object),
    storeDetails: PropTypes.objectOf(PropTypes.object),
    rewardOrPromoFinanceMessage: PropTypes.objectOf(PropTypes.object),
    enableSkipShippingMethodSelections: PropTypes.bool,
    warnings: PropTypes.arrayOf(PropTypes.object),
    isNative: PropTypes.bool,
};

ShippingReviewSection.defaultProps = {
    shippingGroupInfo: {},
    orderCharges: [],
    shipToStore: {},
    storeDetails: {},
    actions: {},
    rewardOrPromoFinanceMessage: {},
    enableSkipShippingMethodSelections: false,
    warnings: [],
    isNative: false,
};

const mapStateToProps = ({
    storeDetails,
    shipToStore,
    orderItems,
    context,
    orderDetails,
    orderInfo,
}) => ({
    storeDetails,
    shipToStore,
    orderItems,
    enableSkipShippingMethodSelections: skipShippingMethodSelection(context, orderDetails),
    warnings: get(orderInfo, 'status.warnings', []),
    isNative: get(context, 'isNative', false),
    truckableDeliveryMessage: get(context, 'preferences.truckableDeliveryMessage', ''),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            ...storeActions,
            ...checkoutAnalyticsActions,
            ...PlaceOrderActions,
            ...OrderInfoAction,
            ...findStoresActions,
            ...checkoutPageActions,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(ShippingReviewSection);
